import { ITooltipComp } from "@ag-grid-community/core";

export class AgInfoTooltip implements ITooltipComp {
    eGui!: HTMLElement;
    init(params) {
      const eGui = (this.eGui = document.createElement('div'));
      eGui.classList.add('validation-tooltip');

      const valueToDisplay = params.value;

      eGui.innerHTML = `
      <div class="ag-info-tooltip-body">${valueToDisplay}</div>
      `;

    }
  
    getGui() {
      return this.eGui;
    }
  }